import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {TextInput, WarningButton, DefaultButton, PrimaryButton,} from '../../../components';

const Container = styled.div`
  margin: 1em;
`;

class AttendingPhysician extends React.Component {
  state = {editing: false, name: ''};

  componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.setState({name: this.props.name})
    }
  }

  onChange = value => this.setState({name: value});

  save = () => {
    this.props.onSave(this.state.name);
    this.setState({editing: false});
  };

  edit = () => this.setState({editing : true});

  cancel = () => {
    this.setState({editing: false, name: this.props.name});
  };

  print = () => {
    this.props.onPrintForm();
  }

  renderEditButton = () => {
    return (
      <WarningButton onClick={this.edit}>Edit</WarningButton>
    );
  }

  renderSaveButton = () => {
    return (
      <React.Fragment>
        <DefaultButton onClick={this.cancel}>Cancel</DefaultButton>
        <span>&nbsp;</span>
        <WarningButton 
          onClick={this.save} 
          disabled={this.state.name === this.props.name}>
          Save</WarningButton>
        
      </React.Fragment>     
    );
  }

  render() {
    const {editing, name} = this.state;
    return (
      <Container className="row">
        <div className="col-sm-6">
          <TextInput 
            value={name} 
            title="Attending Physician" 
            disabled={!editing}
            onChange={this.onChange}/>
        </div>
        <div className="col-sm-6">
          <div>&nbsp;</div>
          {editing ? this.renderSaveButton() : this.renderEditButton()}
          <PrimaryButton className="pull-right" onClick={this.print}>
            Print Form
        </PrimaryButton>
        </div>
        
      </Container>
    );
  }
}


AttendingPhysician.propTypes = {
  name: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onPrintForm: PropTypes.func.isRequired
};

export default AttendingPhysician;



// WEBPACK FOOTER //
// ./src/modules/record/components/AttendingPhysician.js